import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import "./Trainers.css";
import trainer1 from "./../../images/trainer/trainer_1.PNG";
import trainer2 from "./../../images/trainer/trainer_2.PNG";
import trainer3 from "./../../images/trainer/trainer_3.PNG";
import trainer4 from "./../../images/trainer/trainer_4.PNG";

const trainersDetails = [
  {
    name: "Sadia Khan",
    age: 23,
    experience: "8 years",
    Specialization: "Fitness",
    img: trainer1,
  },
  {
    name: "Imran Khan",
    age: 20,
    experience: "8 years",
    Specialization: "Fitness",
    img:
    trainer2,
  },
  {
    name: "Imran Khan",
    age: 20,
    experience: "8 years",
    Specialization: "Fitness",
    img:
    trainer3,
  },
  {
    name: "Imran Khan",
    age: 20,
    experience: "8 years",
    Specialization: "Fitness",
    img:
    trainer4,
  },
];

const Trainers = () => {
  return (
    <div className="mt-5 trainers_div_style">
      <h2 className="text-center brand_text">Our Coaches</h2>

      <div className="trainer_container">
        {trainersDetails.length &&
          trainersDetails.map((trainer) => {
            return (
              <div className="trainer_card">
                <div className="trainer_img">
                  <img src={trainer?.img} alt="me" />
                </div>
                <div className="trainer_content">
                  <h2 className="brand_text">{trainer?.name}</h2>
                  <p>
                    Age:{" "}
                    <span className="font-weight-bold">{trainer?.age}</span>
                  </p>
                  <p>
                    Experience:{" "}
                    <span className="font-weight-bold">
                      {trainer?.experience}
                    </span>{" "}
                  </p>
                  <p>
                    Specialization:{" "}
                    <span className="font-weight-bold">
                      {trainer?.Specialization}
                    </span>{" "}
                  </p>
                </div>
              </div>
            );
          })}

        {/* 2 */}

        {/* <div className="trainer_card">
          <div className="trainer_img">
            <img src={meImg} alt="me" />
          </div>
          <div className="trainer_content">
            <h2>Card One</h2>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus
            illo quam eum, maiores dolorem ea veritatis quibusdam quas, atque
            autem tempora repudiandae nulla fuga perspiciatis molestias?
            Molestiae tenetur minus quas.
          </div>
        </div> */}
      </div>

      {/* <div className="container my-5">
      <h2 className="text-center brand_text">Our Coaches</h2>
      <Row>
        {trainersDetails.map((details) => {
          const { name, age, experience, Specialization, img } = details;
          return (
            <Col xs={12} md={6} lg={3}>
              <Card className="text-center brand_text m-2">
                <Card.Img variant="top" src={img} />
                <Card.Body>
                  <Card.Title>{name}</Card.Title>
                  <p>
                    Age: <span className="font-weight-bold">{age}</span>
                  </p>
                  <p>
                    Experience:{" "}
                    <span className="font-weight-bold">{experience}</span>{" "}
                  </p>
                  <p>
                    Specialization:{" "}
                    <span className="font-weight-bold">{Specialization}</span>{" "}
                  </p>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex justify-content-center">
                    <p>logo</p>
                    <p>logo</p>
                    <p>logo</p>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div> */}
    </div>
  );
};

export default Trainers;

/*****
 * 
 * 
 * <div className="container my-5">
      <h2 className="text-center brand_text">Our Coaches</h2>
      <Row>
        {trainersDetails.map((details) => {
          const { name, age, experience, Specialization, img } = details;
          return (
            <Col xs={12} md={6} lg={3}>
              <Card className="text-center brand_text m-2">
                <Card.Img variant="top" src={img} />
                <Card.Body>
                  <Card.Title>{name}</Card.Title>
                  <p>
                    Age: <span className="font-weight-bold">{age}</span>
                  </p>
                  <p>
                    Experience:{" "}
                    <span className="font-weight-bold">{experience}</span>{" "}
                  </p>
                  <p>
                    Specialization:{" "}
                    <span className="font-weight-bold">{Specialization}</span>{" "}
                  </p>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex justify-content-center">
                    <p>logo</p>
                    <p>logo</p>
                    <p>logo</p>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
 */
